import styled, { css } from 'styled-components';

export default styled.article`
  padding: .5rem;
  max-width: 530px;

  @media all and (min-width: ${({ theme }) => theme.breakingpoints.sm}) {
    padding: 1rem;
  }
  @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
    padding: 2rem;
  }
  p {
    margin: 0 0 1rem 0;
  }

  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 1rem;

  ${({ $fullWidth }) => !$fullWidth && css`
    background-image: linear-gradient(to left, rgba(255,0,0,0), rgba(0,0,0,.8));
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    max-width: 530px;
    padding: .5rem;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.sm}) {
      padding: 1rem;
    }
    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      padding: 2rem;
    }
  `}
  ${({ $fullWidth }) => $fullWidth && css`
    padding: 2rem ${({ theme }) => theme.grid.containerGap};
    max-width: 530px;

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.sm}) {
      padding: 2rem 0;
    }

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
      min-height: 20rem;
    }

    @media all and (min-width: ${({ theme }) => theme.breakingpoints.lg}) {
      min-height: 32rem;
    }
  `}
`;
